import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'DATEDIF',
  category: FunctionCategory.TIMESTAMP,
  description: 'Time difference between dates, measured by specified date partition',
  shortDescription: 'Time difference between dates',
  params: [
    {
      name: 'part',
      type: ArgType.text,
      description: 'The part of the date (example: "month").',
    },
    {
      name: 'start date string',
      type: ArgType.text,
      description: 'The starting date (example: "1992-03-02").',
    },
    {
      name: 'end date string',
      type: ArgType.text,
      description: 'The ending date (example: "1992-03-02").',
    },
  ],
} satisfies AnalysisFunction;
